module.exports = __webpack_public_path__ + "static/img/xingyunlianmeng_.b6cebf60.jpg";